import type { CoreDeal } from '../types';
import type {
  AIDealSuggestion as AIDealSuggestionType,
  AITaskSuggestion as AITaskSuggestionType,
} from './types';

// DEV NOTE: MVP implementation of AI suggestions for deals
export abstract class AIDealSuggestionModel {
  id: string;
  created_at: number;
  deal_id: string;
  field: keyof CoreDeal;
  current_value: CoreDeal[keyof CoreDeal];
  suggested_value: CoreDeal[keyof CoreDeal];
  evidence: string[];
  why_blocking: string;

  constructor(attrs: AIDealSuggestionType) {
    this.id = attrs.id;
    this.created_at = attrs.created_at;
    this.deal_id = attrs.deal_id;
    this.field = attrs.field;
    this.current_value = attrs.current_value;
    this.suggested_value = attrs.suggested_value;
    this.evidence = attrs.evidence;
    this.why_blocking = attrs.why_blocking;
  }
}

export abstract class AITaskSuggestionModel {
  id: string;
  created_at: number;
  deal_id: string;
  title: string;
  description: string;
  priority: 'low' | 'medium' | 'high';
  due_by?: string;
  evidence: string[];
  why_needed: string;

  constructor(attrs: AITaskSuggestionType) {
    this.id = attrs.id;
    this.created_at = attrs.created_at;
    this.deal_id = attrs.deal_id;
    this.title = attrs.title;
    this.description = attrs.description;
    this.priority = attrs.priority;
    this.due_by = attrs.due_by;
    this.evidence = attrs.evidence;
    this.why_needed = attrs.why_needed;
  }
}
